import { TRESPONSE_GET_PLANNING_BOARD } from '@monorepo/types';
import { TIMELINE_MODEL } from '../timeline.model';
import { TBoardView, TEntityActions, TRange, TTimelineModel } from '../timeline.types';
import { getLlStripColorPallet } from '../timeline.utils';
import { getThemeViewDisplayName } from './ll.model';

type TPlanningBoardStrip = TRESPONSE_GET_PLANNING_BOARD['planningBoardDTO']['strips'][number];
type TPlanningBoardTimelineModel = TTimelineModel<TPlanningBoardStrip, TPlanningBoardStrip, TPlanningBoardStrip>;
export type TPlanningBoardEntityActions = TEntityActions<TPlanningBoardStrip, TPlanningBoardStrip, TPlanningBoardStrip>;

export const PLANNING_BOARD_TIMELINE_MODEL = {
  createModel: (res: TRESPONSE_GET_PLANNING_BOARD): TPlanningBoardTimelineModel => {
    const boardView: TBoardView = {
      boardViewType: res.planningBoardDTO.boardView.boardViewType,
      themeView: {
        key: res.planningBoardDTO.customView.viewMode,
        displayName: getThemeViewDisplayName(res.planningBoardDTO.customView.viewMode),
      },
      dateRange: res.planningBoardDTO.boardView.dateRange,
      currentDate: res.planningBoardDTO.boardView.currentDate,
    };

    return TIMELINE_MODEL.createTimelineModel<TPlanningBoardStrip, TPlanningBoardStrip, TPlanningBoardStrip>(
      boardView,
      res.planningBoardDTO.strips,
      (strip) => ({
        id: `planning_board_group ${strip.oplId}`,
        name: 'Planning Board',
        data: strip,
        entities: [
          {
            id: `planning_board_row ${strip.oplId}`,
            name: { displayTxt: strip.userOPLId, isClickable: true },
            data: strip,
            elements: [
              {
                type: 'STRIP' as const,
                id: `planning_board_strip ${strip.oplId}`,
                data: strip,
                color: getLlStripColorPallet(strip.stripColor).color,
                iconList: [],
                mask: false,
                name: strip.userOPLId,
                range: { startDate: strip.dateRange.from, endDate: strip.dateRange.to } as TRange,
                stackCount: 0,
                textList: [
                  {
                    value: `${strip.allocatedCapacity}/${strip.installedCapacity}`,
                    color: '#000',
                    align: 'center',
                    justify: 'center',
                    fontSizeInPx: 16,
                  },
                ],
              },
            ],
          },
        ],
        holidays: [],
      }),
      false,
    );
  },
};
